const FIO_ALLOWED_CHARS_REGEXP = /[^А-Яа-яЁёA-Za-z \-'‘.`]+/g;
const FIO_TRIM_LEADING_SEPARATORS_REGEXP = /^[\- '‘.`]+/;
const FIO_COLLAPSE_SEPARATORS_REGEXP = /([\- '‘.`])\1+/g;

const CARDHOLDER_NAME_ALLOWED_CHARS_REGEXP = /[^A-Za-z \-`‘']+/g;
const CARDHOLDER_NAME_TRIM_LEADING_SEPARATORS_REGEXP = /^[\- `‘']+/;
const CARDHOLDER_NAME_COLLAPSE_SEPARATORS_REGEXP = /([\- `‘'])\1+/g;
export const CARDHOLDER_NAME_MAX_LENGTH = 50;

export const normalizeFIO = (value = '') =>
  String(value)
    .replaceAll(FIO_ALLOWED_CHARS_REGEXP, '')
    .replace(FIO_TRIM_LEADING_SEPARATORS_REGEXP, '')
    .replace(FIO_COLLAPSE_SEPARATORS_REGEXP, '$1');

/**
 * Нормализует имя держателя карты для moyopros-kz
 * Правила: только латиница, автоматически в заглавные, пробел/дефис - максимум 1 подряд, длина до 50
 */
export const normalizeCardholderName = (value = '') => {
  const normalized = String(value)
    .replaceAll(CARDHOLDER_NAME_ALLOWED_CHARS_REGEXP, '')
    .replace(CARDHOLDER_NAME_TRIM_LEADING_SEPARATORS_REGEXP, '')
    .replace(CARDHOLDER_NAME_COLLAPSE_SEPARATORS_REGEXP, '$1')
    .toUpperCase()
    .slice(0, CARDHOLDER_NAME_MAX_LENGTH);
  return normalized;
};
